import { Button, Flex, Input } from "djuno-design";
import PlusIcon from "./../../assets/icons/plus.svg?react";
import MinusIcon from "./../../assets/icons/minus.svg?react";

export const NumberStepper: React.FC<{
  value: number;
  min: number;
  max: number;
  onChange?: (value: number) => void;
  error?: string;
}> = ({ value, min = 0, max = 10, onChange, error }) => {
  const handlePlus = () => {
    if (value + 1 <= max && onChange) {
      onChange(value + 1);
    }
  };
  const handleMinus = () => {
    if (value - 1 >= min && onChange) {
      onChange(value - 1);
    }
  };

  return (
    <Flex items="center" className="gap-1">
      <Button
        disabled={value <= min}
        uiType={`light`}
        className="!px-2"
        onClick={handleMinus}
      >
        <MinusIcon className="w-4 text-slate-800 dark:text-zinc-50" />
      </Button>
      <Input
        className="!w-16"
        error={error}
        value={value}
        type="number"
        readOnly
      />

      <Button
        disabled={value >= max}
        uiType={`light`}
        className="!px-2"
        onClick={handlePlus}
      >
        <PlusIcon className="w-4 text-slate-800 dark:text-zinc-50" />
      </Button>
    </Flex>
  );
};
